import { GET_RESTAURANT_SETTINGS } from '../actions/restaurantSettings';

export interface RestaurantSettingsState {
  error: unknown;
  loaded: boolean;
  loading: boolean;
  data: Record<string, unknown> | null;
}

const initialState: RestaurantSettingsState = {
  error: null,
  loaded: false,
  loading: false,
  data: null,
};

export default function restaurantSettings(
  state: RestaurantSettingsState = initialState,
  action: any = {},
): RestaurantSettingsState {
  switch (action.type) {
    case `${GET_RESTAURANT_SETTINGS}_PENDING`:
      return { ...state, error: null, loading: true };
    case `${GET_RESTAURANT_SETTINGS}_SUCCESS`:
      return {
        error: null,
        loaded: true,
        loading: false,
        data: action.result,
      };
    case `${GET_RESTAURANT_SETTINGS}_FAIL`:
      return { ...state, error: action.error, loaded: false, loading: false };
    default:
      return state;
  }
}
